import { Link } from "react-router-dom";

export function StepFooter({ selectedBrandId, linkNext, linkBack }) {
  return (
    <div
      className="w-4/5 md:w-3/4 m-auto mt-10  flex justify-between py-8 px-5 "
      style={{
        backgroundImage:
          "linear-gradient(to right, #333 10%, rgba(255, 255, 255, 0) 0%)",
        backgroundPosition: "top",
        backgroundSize: "15px 1.5px",
        backgroundRepeat: "repeat-x",
      }}
    >
      {linkBack && (
        <Link to={`/pages/dashboard/${linkBack}`}>
          <div className="flex items-center">
            <img src="/assets/arrowstep.svg" className="h-9 md:h-10" />
            <p className="uppercase font-medium ml-8 hidden md:text-sm md:block">
              {`étape précédente`}
            </p>
          </div>
        </Link>
      )}
      {linkNext && (
        <Link to={`/pages/dashboard/${linkNext}`}>
          <div className="flex items-center">
            <p className="uppercase font-medium mr-8 hidden md:text-sm md:block">
              {`étape suivante`}
            </p>
            <img
              src="/assets/arrowstep.svg"
              className="h-9 md:h-10 rotate-180"
            />
          </div>
        </Link>
      )}
    </div>
  );
}
